<template>
  <div :class="smAndDown ? 'px-0': 'px-10'" class="main d-flex justify-center" style="background-color: #EEF5F9 ; border-radius: 15px;">
    <div v-if="!loading" style="max-width: 1600px;" class="mx-auto">
      <v-row class="mb-lg-2" align="center" justify="center">
        <v-col cols="12" sm="6" md="4" class="d-flex justify-center">
          <code-month-graph :data="graficaProgress" :subtitle="codeName" />
        </v-col>
           <v-col cols="12" sm="6" md="4" class="d-flex justify-center">
            <WidgetItem
              :number="numberWithCommas(lastMonth)"
              detail="Último mes"
              :state="formatPercent(lastMonthPercent)"
            />
            </v-col> 
            <v-col cols="12" sm="6" md="4" class="d-flex justify-center">
            <WidgetItem
              :number="numberWithCommas(lastYear)"
              detail="Último año"
              :state="formatPercent(lastYearPercent)"
            />
            </v-col> 
      </v-row>
      <v-row class="justify-lg-space-around mb-lg-2">

        <v-col cols="12" lg="4" :class="smAndDown ? '': ''">
          <UtilitiesObtainedGraph/>
        </v-col>
        <v-col cols="12" lg="4" :class="smAndDown ? '': ''">
          <UtilitiesObtainedGraphDaily/>
        </v-col>
       <v-col cols="12" lg="4" class="d-flex px-lg-4 mb-6" :class="smAndDown ? 'justify-center': 'justify-end'">
        <IncomesByCategoryDonut />
      </v-col>
      </v-row>

      <v-row class="mb-lg-6">
        <v-col cols="12">
          <v-card class="pa-4" style="background:#FFF;border-radius:15px;">
            <div class="d-flex flex-wrap" style="gap:12px;align-items:center;">
              <strong class="mr-4" style="font-size:16px;">Filtros globales</strong>

              <!-- Categorías (multiple) -->
              <v-select
                v-model="globalCategories"
                :items="categorias"
                item-text="nombre"
                item-value="slug"
                label="Categorías de sección"
                multiple chips
                dense outlined hide-details clearable
                style="max-width:260px;"
                @change="onGlobalCategoryChange"
              />

              <!-- Sección dependiente de categoría -->
              <v-select
                v-model="globalSections"
                :items="seccionesGlobal"
                item-text="nombre"
                item-value="id"
                label="Secciones"
                multiple chips
                dense outlined hide-details clearable
                style="max-width:220px;"
                @change="applyGlobalFilters"
              />

              <!-- Rango de fechas -->
              <v-text-field v-model="globalStartDate" type="date" label="Desde" dense outlined hide-details
                            style="max-width:180px;" @change="applyGlobalFilters"/>
              <v-text-field v-model="globalEndDate" type="date" label="Hasta" dense outlined hide-details
                            style="max-width:180px;" @change="applyGlobalFilters"/>

              <!-- Toggle: incluir secciones inactivas -->
              <v-switch
                v-model="includeInactiveSections"
                inset
                class="ml-4"
                hide-details
                label="Secciones inactivas"
                @change="onIncludeInactiveChanged"
              />
              <v-spacer></v-spacer>

              <v-btn small depressed class="mr-2" @click="resetGlobalFilters(); clearChildFilters()">Limpiar</v-btn>
              <v-btn small color="primary" depressed @click="applyGlobalFilters">Aplicar</v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="justify-lg-space-around mb-lg-6">
        <v-col cols="12" lg="4" class="d-flex justify-center align-center">
          <NumberOfMatriculeGraph
            :global-categories="globalCategories"
            :global-sections="globalSections"
            :global-start-date="globalStartDate"
            :global-end-date="globalEndDate"
            :global-section-name="sectionName"
          />
        </v-col>
          <v-col cols="12" lg="4" :class="smAndDown ? '': ''">
          <UtilitiesObtainedGraph 
            ref="utilitiesGraph"
            :global-categories="globalCategories"
            :global-sections="globalSections"
            :global-start-date="globalStartDate" 
            :global-end-date="globalEndDate"
            :show-course-filter="true"
          />
        </v-col>
        <v-col cols="12" lg="4" :class="smAndDown ? '': ''">
          <UtilitiesObtainedGraphDaily
            ref="utilitiesGraphDayly"
            :global-categories="globalCategories"
            :global-sections="globalSections"
            :global-start-date="globalStartDate"
            :global-end-date="globalEndDate"
            :show-course-filter="true"
          />
        </v-col>
      </v-row>

      <v-row class="mb-lg-3" align="stretch">
        <v-col cols="12" lg="4" class="d-flex px-lg-4 mb-6" :class="smAndDown ? 'justify-center': 'justify-end'">
          <IncomesBySectionDonut
            ref="donutIngresos"
            :global-start-date="globalStartDate"
            :global-end-date="globalEndDate"
            :global-categories="globalCategories"
            :include-inactive="includeInactiveSections"
          />
        </v-col>
        <v-col cols="12" lg="3" class="d-flex px-lg-4 mb-6" :class="smAndDown ? 'd-flex justify-center align-center': 'pl-0 pr-10'">
          <UniversityStudentsTable :items="universitiesList">
            <template #filters>
              <v-select
                v-model="selectedSeccion"
                :items="secciones"
                item-text="nombre"
                item-value="id"
                label="Filtrar por sección"
                clearable
                dense
                outlined
                hide-details
                style="max-width: 320px; margin: 0 auto;"
                @change="fetchStudentsByUniversity"
              />
            </template>
          </UniversityStudentsTable>
        </v-col>
        <v-col cols="12" lg="5" class="d-flex px-lg-4 mb-6" :class="smAndDown ? 'justify-center': 'justify-end'">
          <AgeStudentsGraph
            ref="ageGraph"
            :global-categories="globalCategories"
            :global-sections="globalSections"
            :global-start-date="globalStartDate"
            :global-end-date="globalEndDate"
            :include-inactive="includeInactiveSections"
          />
        </v-col>

      </v-row>
      <v-row class="justify-lg-space-around mb-lg-4">
        <v-col cols="12" lg="4" class="d-flex justify-center align-center px-lg-4 mb-6">
          <ReferencesChannelsDonut
            :global-categories="globalCategories"
            :global-sections="globalSections"
            :global-start-date="globalStartDate"
            :global-end-date="globalEndDate"
            :include-inactive="includeInactiveSections"
            :section-name="sectionName"
            ref="donutReferidos"
          />
        </v-col>
        <!--Estudiantes con cuotas pendientes -->
        <v-col cols="12" lg="4" class="px-lg-4 mb-6" :class="smAndDown ? 'd-flex justify-center align-center': 'pl-0 pr-10'">
          <StudentsPendingGraph :data="graficaPendientes" title="Estudiantes con cuotas pendientes">
            <template #filters>
              <div class="d-flex flex-wrap" style="gap: 12px; justify-content:center;">
                <v-select
                  v-model="estadoSeccion"
                  :items="estadoSeccionItems"
                  item-text="text"
                  item-value="value"
                  label="Estado de curso"
                  dense outlined hide-details
                  style="max-width: 200px;"
                  @input="onEstadoSeccionChanged"
                />
                <v-select
                  v-model="selectedSeccionPend"
                  :items="seccionesFiltradas"
                  item-text="nombre"
                  item-value="id"
                  :return-object="false"
                  label="Sección"
                  clearable dense outlined hide-details
                  style="max-width: 280px;"
                  @input="fetchStudentsPendingGraph"
                />
              </div>
            </template>
          </StudentsPendingGraph>
        </v-col>
          <!--Monto pendiente por sección --> 
        <v-col cols="12" lg="4" class="px-lg-4 mb-6 d-flex" :class="smAndDown ? 'justify-center': 'justify-end'">
          <StudentsPendingGraph :data="graficaDeuda" title="Monto pendiente por sección (S/)">
            <template #filters>
              <div class="d-flex flex-wrap" style="gap: 12px; justify-content:center;">
                <v-select
                  v-model="estadoSeccion"
                  :items="estadoSeccionItems"
                  item-text="text"
                  item-value="value"
                  label="Estado de curso"
                  dense outlined hide-details
                  style="max-width: 200px;"
                  @input="onEstadoSeccionChanged"
                />
                <v-select
                  v-model="selectedSeccionPend"
                  :items="seccionesFiltradas"
                  item-text="nombre"
                  item-value="id"
                  :return-object="false"
                  label="Sección"
                  clearable dense outlined hide-details
                  style="max-width: 280px;"
                  @input="fetchPendingAmountGraph"
                />
              </div>
            </template>
          </StudentsPendingGraph>
        </v-col>
      </v-row>
    </div>

    <div class="d-flex justify-center" v-else>
      <v-progress-circular indeterminate />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { settingsLinePlot } from '@/utils/graphs/ingresos'
import { settingsProgressBar } from '@/utils/graphs/progreso'
import { settingsStackedBar } from '@/utils/graphs/canales'
import { settingsBars } from '@/utils/graphs/edades'
import WidgetItem from '@/components/dashboardComponents/dashboard/WidgetItem.vue'
import CodeMonthGraph from '@/components/dashboardComponents/dashboard/CodeMonthGraph.vue'
import UniversityStudentsTable from '@/components/dashboardComponents/dashboard/UniversityStudentsTable.vue'
import AgeStudentsGraph from '@/components/dashboardComponents/dashboard/AgeStudentsGraph.vue'
import UtilitiesObtainedGraph from '@/components/dashboardComponents/dashboard/UtilitiesObtainedGraph.vue'
import UtilitiesObtainedGraphDaily from '@/components/dashboardComponents/dashboard/UtilitiesObtainedGraphDaily.vue'
import NumberOfMatriculeGraph from '@/components/dashboardComponents/dashboard/NumberOfMatriculeGraph.vue'
import StudentsPendingGraph from '@/components/dashboardComponents/dashboard/StudentsPendingGraph.vue'
import IncomesBySectionDonut from '@/components/dashboardComponents/dashboard/IncomesBySectionDonut.vue'
import ReferencesChannelsDonut from '@/components/dashboardComponents/dashboard/ReferencesChannelsDonut.vue'
import IncomesByCategoryDonut from '@/components/dashboardComponents/dashboard/IncomesByCategoryDonut.vue'

export default {
  components: {
    WidgetItem,
    CodeMonthGraph,
    UniversityStudentsTable,
    AgeStudentsGraph,
    UtilitiesObtainedGraph,
    UtilitiesObtainedGraphDaily,
    NumberOfMatriculeGraph,
    StudentsPendingGraph,
    IncomesBySectionDonut,
    IncomesByCategoryDonut,
    ReferencesChannelsDonut,
  },
  data: () => ({
    graficLine: settingsLinePlot,
    graficaProgress: settingsProgressBar,
    graficaStacked: settingsStackedBar,
    graficaBarras: settingsBars,
    graficaPendientes: {
      options: {
        ...settingsBars.options,
        xaxis: {
          ...settingsBars.options.xaxis,
          title: { ...(settingsBars.options.xaxis?.title || {}), text: 'Sección' },
          categories: []
        }
      },
      series: [{ name: 'Alumnos', data: [] }]
    },
    graficaDeuda: {
      options: {
        ...settingsBars.options,
        xaxis: {
          ...settingsBars.options.xaxis,
          title: { ...(settingsBars.options.xaxis?.title || {}), text: 'Sección' },
          categories: []
        }
      },
      series: [{ name: 'S/ Pendiente', data: [] }]
    },
    estadoSeccion: '',
    selectedSeccionPend: null,
    estadoSeccionItems: [
      { text: 'Todos', value: '' },
      { text: 'Activos', value: true },
      { text: 'Inactivos', value: false }
    ],
    codeName: '',
    universitiesList: [],
    secciones: [],
    selectedSeccion: null,
    selectedSeccionAges: null,
    ageStartDate: '',
    ageEndDate: '',
    selectedSeccionRef: null,
    categorias: [],
    globalCategories: [],
    globalSections:   [],
    includeInactiveSections: false,
    globalCategory: null,
    seccionesGlobal: [],
    globalSeccion: null,
    globalStartDate: '',
    globalEndDate: '',
    lastMonth: 0,
    lastMonthPercent: 0,
    lastYear: 0,
    lastYearPercent: 0,
    loading: true
  }),
  computed: {
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    },
    globalCategoryOne () {
    return Array.isArray(this.globalCategories) && this.globalCategories.length === 1
      ? this.globalCategories[0]
      : null
    },
    globalSectionOne () {
    return Array.isArray(this.globalSections) && this.globalSections.length === 1
      ? this.globalSections[0]
      : null
    },
    seccionesFiltradas () {
      if (!this.secciones || typeof this.secciones[0]?.activo === 'undefined') return this.secciones
      if (this.estadoSeccion === '') return this.secciones
      return this.secciones.filter(s => s.activo === this.estadoSeccion)
    },
  sectionName () {
      if (this.globalSectionOne) {
        const s = (this.seccionesGlobal || []).find(x => x.id === this.globalSectionOne)
        return s ? s.nombre : ''
      }
      return '' // si hay 0 o >1, no mostramos nombre
    },
  },
  watch: {
    globalStartDate(newVal) {
      if (!this.ageStartDate) this.ageStartDate = newVal
    },
    globalEndDate(newVal) {
      if (!this.ageEndDate) this.ageEndDate = newVal
    },
    globalSeccion(newVal) {
      this.selectedSeccionAges = newVal
      this.selectedSeccion = newVal
      this.selectedSeccionPend = newVal
      this.selectedSeccionRef = newVal
    }
  },
  methods: {
    getLastTwelveMonths() {
      const temporaryStartDate = new Date()
      temporaryStartDate.setMonth(temporaryStartDate.getMonth() - 12)
      this.globalStartDate = temporaryStartDate.toISOString().substring(0, 10)
      this.ageStartDate = temporaryStartDate.toISOString().substring(0, 10)

      const temporaryEndDate = new Date()
      this.globalEndDate = temporaryEndDate.toISOString().substring(0, 10)
      this.ageEndDate = temporaryEndDate.toISOString().substring(0, 10)
    },
    formatPercent(decimal) {
      const number = Math.round(decimal * 10000) / 100
      return `${number > 0? '+': ''}${(number).toFixed(2)}%`;
    },
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    clearChildFilters() {
      this.$refs.utilitiesGraph.clearFilters()
      this.$refs.utilitiesGraphDayly.clearFilters()
      this.$refs.ageGraph.clearFilters()
      this.$refs.donutIngresos?.clearFiltersAndReload()
      this.$refs.donutReferidos?.clearFiltersAndReload()
    },
    async fetchSecciones () {
      const { data } = await axios.get('api/matriculas/secciones/')
      this.secciones = data
    },
    async fetchCategorias () {
      const { data } = await axios.get('api/formulario/categorias_seccion/')
      this.categorias = data
    },
  async fetchSeccionesGlobal () {
    if (this.globalCategories && this.globalCategories.length > 0) {
      const requests = this.globalCategories.map(slug =>
        axios.get(`api/formulario/categorias_seccion/${slug}/secciones/`,
        { params: this.includeInactiveSections ? { include_inactive: 1 } : {} }
        )
      )
      const arrays = (await Promise.all(requests)).map(r => r.data || [])
      const map = new Map()
      arrays.flat().forEach(s => map.set(s.id, s))
      this.seccionesGlobal = Array.from(map.values())
    } else {
      const { data } = await axios.get('api/matriculas/secciones/', {
        params: this.includeInactiveSections ? { include_inactive: 1 } : {}})
      this.seccionesGlobal = data
    }
  },
    async onGlobalCategoryChange () {
      if (this.globalCategories?.length) this.globalSections = []
      await this.fetchSeccionesGlobal()
      this.applyGlobalFilters()
    },
    onIncludeInactiveChanged () {
    this.fetchSeccionesGlobal()
    this.applyGlobalFilters()
    this.$refs.donutIngresos?.clearFiltersAndReload?.()
    this.$refs.ageGraph?.fetchData?.()
    this.$refs.donutReferidos?.reload?.()
  },
    resetGlobalFilters () {
      this.globalCategories = []
      this.globalSections = []
      this.includeInactiveSections = false
      this.selectedSeccion = null
      this.selectedSeccionAges = null
      this.selectedSeccionRef = null
      this.selectedSeccionPend = null
      this.globalCategory = null
      this.globalSeccion = null
      this.globalStartDate = ''
      this.globalEndDate = ''
      this.ageStartDate = ''
      this.ageEndDate = ''
      this.fetchSeccionesGlobal()
      this.applyGlobalFilters()
      this.$refs.donutIngresos?.clearFiltersAndReload?.()
      this.$refs.ageGraph?.fetchData?.()
      this.$refs.donutReferidos?.reload?.()
    },
    applyGlobalFilters () {
      this.fetchStudentsByUniversity()
      this.fetchStudentsPendingGraph()
      this.fetchPendingAmountGraph()
    },
    async fetchCodes () {
      const { data } = await axios.get('api/admin/matriculas/codigos_referencia/codigo_mas_usado_mes/')
      this.graficaProgress.series = [data.cantidad_matriculas]
      this.codeName = data.codigo
    },
    async fetchWidgetMonth () {
      const { data } = await axios.get('api/admin/matriculas/pagos/ventas_ultimo_mes/')
      this.lastMonth = data.ventas_ultimo_mes
      const p = await axios.get('api/admin/matriculas/pagos/porcentaje_ventas_ultimo_mes/')
      this.lastMonthPercent = p.data.porcentaje_ventas
    },
    async fetchWidgetYear () {
      const { data } = await axios.get('api/admin/matriculas/pagos/ventas_ultimo_anio/')
      this.lastYear = data.ventas_ultimo_anio
      const p = await axios.get('api/admin/matriculas/pagos/porcentaje_ventas_ultimo_anio/')
      this.lastYearPercent = p.data.porcentaje_ventas_anual
    },
    async fetchStudentsByUniversity () {
      const params = new URLSearchParams()
        if (this.globalStartDate) params.set('fecha_inicio', this.globalStartDate)
        if (this.globalEndDate)   params.set('fecha_fin',   this.globalEndDate)
        params.set('data_size', '12')
        if (this.includeInactiveSections) params.set('include_inactive', '1')
        if (this.selectedSeccion) {
          params.append('seccion', this.selectedSeccion)
        } else {
          const secs = Array.isArray(this.globalSections) ? this.globalSections.filter(x => !!x) : []
          const cats = Array.isArray(this.globalCategories) ? this.globalCategories.filter(x => !!x) : []
          if (secs.length) {
            secs.forEach(id => params.append('seccion', id))
          } else if (cats.length) {
            cats.forEach(slug => params.append('categoria', slug))
          }
        }
      const { data } = await axios.get(`api/admin/graficas/cantidad_estudiantes_por_universidad/?${params.toString()}`)
      this.universitiesList = data
    },
    buildEstadoParam () { return this.estadoSeccion === '' ? undefined : this.estadoSeccion },
    async fetchStudentsPendingGraph () {
      const params = {
        activo: this.buildEstadoParam(),
        seccion: this.selectedSeccionPend || this.globalSeccion || undefined,
        fecha_inicio: this.globalStartDate || undefined,
        fecha_fin: this.globalEndDate || undefined
      }
      const { data } = await axios.get('api/admin/graficas/estudiantes_pendientes_por_seccion/', { params })
      const categorias = data.map(d => d.seccion_nombre)
      const valores = data.map(d => d.alumnos_pendientes)

      this.graficaPendientes = {
        options: {
          ...this.graficaPendientes.options,
          xaxis: { ...this.graficaPendientes.options?.xaxis, categories: categorias }
        },
        series: [{ name: 'Alumnos', data: valores }]
      }
    },
    async fetchPendingAmountGraph () {
      const params = {
        activo: this.buildEstadoParam(),
        seccion: this.selectedSeccionPend || this.globalSeccion || undefined,
        fecha_inicio: this.globalStartDate || undefined,
        fecha_fin: this.globalEndDate || undefined
      }
      const { data } = await axios.get('api/admin/graficas/monto_pendiente_por_seccion/', { params })
      const categorias = data.map(d => d.seccion_nombre)
      const valores = data.map(d => Number(d.monto_pendiente || 0))

      this.graficaDeuda = {
        options: {
          ...this.graficaDeuda.options,
          xaxis: { ...this.graficaDeuda.options?.xaxis, categories: categorias }
        },
        series: [{ name: 'S/ Pendiente', data: valores }]
      }
    },
    onEstadoSeccionChanged () {
      this.selectedSeccionPend = null
      this.fetchStudentsPendingGraph()
      this.fetchPendingAmountGraph()
    }
  },
  async created () {
    await this.fetchSecciones()
    await this.fetchCategorias()
    await this.fetchSeccionesGlobal()
    await this.fetchCodes()
    await this.fetchWidgetMonth()
    await this.fetchWidgetYear()
    await this.applyGlobalFilters()
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.list {
  &__header {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #455A64;
  }
}
.bars {
  &__wrapper {
    width: 100%;
    height: 50 0px;
    background: #FFF;
    box-sizing: border-box;
    border-radius: 15px;
  }
}
</style>